import React from "react";
import styled from "styled-components";

import { color, fontFamily, fontSize, spacingDefaults } from "style/constants";

export const ChartContainer = styled.div`
  background: ${color.WHITE};
  width: 100%;
  max-width: 572px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  padding: ${spacingDefaults.normal} ${spacingDefaults.large}
    ${spacingDefaults.normal} ${spacingDefaults.normal};
`;

export const Title = styled.h2`
  font-family: ${fontFamily.secondary};
  font-weight: 400;
  font-size: ${fontSize.normal};
  line-height: 1.5;
  color: ${color.BLACK};
  text-align: center;
  margin: 0;
`;

export const RangeButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: ${spacingDefaults.normal};
  margin: ${spacingDefaults.normal} 0;
`;

interface RangeButtonProps {
  active?: boolean;
}

export const RangeButton = styled(
  ({
    active,
    ...props
  }: RangeButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button {...props} />
  )
)<RangeButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${spacingDefaults.xxsmall} ${spacingDefaults.xsmall};
  white-space: nowrap;
  background: ${({ active }) =>
    active ? color.SCORE_CHART_LINE : color.GRAY_PROGESS_BAR};
  border: none;
  border-radius: 15px; /* pill shape per Figma */
  font-family: ${fontFamily.primary};
  font-weight: ${({ active }) => (active ? 400 : 300)};
  font-size: ${fontSize.xsmall};
  color: ${({ active }) => (active ? color.WHITE : color.BLACK)};
  cursor: pointer;
`;
